import { ResourceLanguage } from 'i18next';
import { UseTranslationResponse, useTranslation as useTrans } from 'react-i18next';
import useGlobalTranslation from './useGlobalTranslation';

function useTranslation(
  namespace: string,
  fallback: ResourceLanguage,
  keys?: unknown
): UseTranslationResponse<string, string> {
  const globalTranslation = useGlobalTranslation();
  if (!!globalTranslation) {
    return globalTranslation(namespace, keys);
  } else {
    const fallbackLng = 'en';
    const response = useTrans(namespace, { useSuspense: true });

    if (response.ready && !response.i18n.hasResourceBundle(fallbackLng, namespace)) {
      response.i18n.addResourceBundle(fallbackLng, namespace, fallback, true, true);
    }

    return response;
  }
}
export default useTranslation;
